export const persian = {
    0: '۰', 
    1: '۱', 
    2: '۲', 
    3: '۳', 
    4: '۴', 
    5: '۵', 
    6: '۶', 
    7: '۷', 
    8: '۸', 
    9: '۹'
};

export const toRial = (number)=>{
    return number * 10;
    // :D What the hell is that
    let num = number.toString() + '0';
    let res = num.match(/\d+/g).join([])
    return res
}

export const masckNumber = (number) =>{
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const separateBy = (data, interval, delimiter) => {
    let regex = new RegExp('\\B(?=(\\d{' + interval + '})+(?!\\d))', 'g');
    return data.toString().replace(regex, delimiter);
}

export const zeroOutLastDigits = (numberStr, digit = 6) => {
      // تابع تبدیل اعداد فارسی به لاتین
      const persianToEnglish = (str) => {
        const persianNumbers = [
          "۰",
          "۱",
          "۲",
          "۳",
          "۴",
          "۵",
          "۶",
          "۷",
          "۸",
          "۹",
        ];
        const englishNumbers = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
        ];

        let result = str;
        for (let i = 0; i < persianNumbers.length; i++) {
          result = result.replace(
            new RegExp(persianNumbers[i], "g"),
            englishNumbers[i],
          );
        }
        return result;
      };

      // تابع تبدیل اعداد انگلیسی به فارسی
      const englishToPersian = (str) => {
        const persianNumbers = [
          "۰",
          "۱",
          "۲",
          "۳",
          "۴",
          "۵",
          "۶",
          "۷",
          "۸",
          "۹",
        ];
        const englishNumbers = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
        ];

        let result = str;
        for (let i = 0; i < englishNumbers.length; i++) {
          result = result.replace(
            new RegExp(englishNumbers[i], "g"),
            persianNumbers[i],
          );
        }
        return result;
      };

      // حذف کاماها و تبدیل اعداد فارسی به انگلیسی
      let cleanNumber = numberStr.replace(/,/g, "");
      cleanNumber = cleanNumber.replace(/٬/g, "");

      
      cleanNumber = persianToEnglish(cleanNumber);

      // اگر طول عدد ۶ رقم یا کمتر بود، بدون تغییر برگردان
      if (cleanNumber.length <= 6) {
        return numberStr; // برگرداندن مقدار اصلی با فرمت اولیه
      }

      // در غیر این صورت، ۶ رقم آخر را صفر کن
      let prefix = cleanNumber.slice(0, -digit);
      let resultNumber = prefix + "0".repeat(digit);

      // تبدیل اعداد انگلیسی به فارسی
      resultNumber = englishToPersian(resultNumber);
      // بازگرداندن کاماها برای خروجی خواناتر (اختیاری)
      return Number(persianToEnglish(resultNumber)).toLocaleString("fa-IR");
}

export const toPersianNumber = (text) => {
    let res = text.toString();
    if (res) {
        let list = res.match(/[0-9]/g);
        if (list !== null && list.length !== 0) {
            for (let i = 0; i < list.length; i++)
                res = res.replace(list[i], persian[list[i]]);
        }
    }
    return res
}